import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ExternalIntegration } from 'dashboard/models/external-integration';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiEndpoint, ApiListResponse, ApiModel } from 'lib/interfaces/api';

const api = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    listExternalIntegrations: builder.query<ExternalIntegration[], void>({
      query: async () =>
        await SessionClientDashboard.listResource<ExternalIntegration>(
          ApiEndpoint.ExternalIntegration,
        ),
      transformResponse: (response: ApiListResponse<ExternalIntegration>) => response.data,
      providesTags: () => [{ type: ApiModel.ExternalIntegration, id: 'LIST' }],
    }),
    archiveExternalIntegration: builder.mutation<void, ExternalIntegration>({
      query: async (config) =>
        await SessionClientDashboard.postResourceAction<ExternalIntegration>(config, 'archive'),
      invalidatesTags: () => [{ type: ApiModel.ExternalIntegration, id: 'LIST' }],
    }),
  }),
});

export const { useListExternalIntegrationsQuery, useArchiveExternalIntegrationMutation } = api;
